<template>
  <v-col>
    <Formulario v-if="processo" :processo="processo" />
  </v-col>
</template>

<script>
import Formulario from "@/pages/Processo/components/FormProcesso";
export default {
  name: "editar-processo",

  components: {
    Formulario
  },

  props: {
    id: String
  },

  data: () => ({
    processo: null,
    showForm: false
  }),

  mounted() {
    this.carregarProcesso();
  },

  methods: {
    async carregarProcesso() {
      this.processo = await this.$http
        .get(`processo-inscricao/${this.id}`)
        .catch(error => {
          this.showMessage(error, "error");
        });
    }
  }
};
</script>
